import type { IndividualReport } from 'chaika-frontend-types/frontend-cms';

import { SimpleList } from '@store/models/SimpleList';
import { IndividualReportType } from 'chaika-enums';

export interface IndividualReportFilterParams {
    legalEntityId?: string;
    type?: IndividualReportType;
}

export class IndividualReportsList extends SimpleList<IndividualReport, IndividualReportFilterParams> {
    protected filterValue(value: IndividualReport, { legalEntityId, type }: IndividualReportFilterParams): boolean {
        return (
            this.filterFieldValue(value, legalEntityId, 'legalEntityId') && this.filterFieldValue(value, type, 'type')
        );
    }
}
